/** Info panel (book icon) is page index 0; mnemonics (lightbulb) is page index 1. */
const TRAILING_SLASH_REGEX = /\/$/;

export function resolveActiveMorphemePanelPageIndex(pathname: string): 0 | 1 {
  const normalizedPathname = pathname.replace(TRAILING_SLASH_REGEX, "");
  if (normalizedPathname.endsWith("/mnemonics")) {
    return 1;
  }
  return 0;
}
